/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Committedorganisations_Organisation2Inputs */

const en_coinvestments_report_committedorganisations_organisation2 = /** @type {(inputs: Coinvestments_Report_Committedorganisations_Organisation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "Organisation" |
*
* @param {Coinvestments_Report_Committedorganisations_Organisation2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_committedorganisations_organisation2 = /** @type {((inputs?: Coinvestments_Report_Committedorganisations_Organisation2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Committedorganisations_Organisation2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_committedorganisations_organisation2(inputs)
});
export { coinvestments_report_committedorganisations_organisation2 as "coInvestments_report_committedOrganisations_organisation" }